module.exports = __webpack_public_path__ + "static/singleparent-ebf92937331e5814ceafe45b9be7865a.jpg";